import boxShadows from "assets/theme/box-shadow.js";
import hexToRgb from "assets/theme/hex-to-rgb";
import themeColors from "assets/theme/colors";

const componentStyles = (theme) => ({
    appBarRoot: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
        // paddingLeft: "250px",
        // backgroundColor: theme.palette.background.default,
        background: "rgba(" + hexToRgb(themeColors.primary.text) + ", 0.6)",
        borderBottomColor: "rgba(" + hexToRgb(themeColors.primary.text) + ", 0.8)",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        color: theme.palette.text.primary,
    },
    toolbarRoot: {
        minHeight: 50,
        maxHeight: 50
    },
    brandTitle: {
        textTransform: "uppercase",
        margin: "0",
        color: theme.palette.adminNavbarSearch.main,
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    searchBox: {
        padding: ".25rem .25rem",
        borderColor: theme.palette.adminNavbarSearch.main,
        borderRadius: "2rem",
        border: "2px solid",
        backgroundColor: "initial",
        boxShadow: boxShadows.inputBoxShadow,
        transition: "box-shadow .15s ease",
    },
    searchIcon: {
        color: theme.palette.adminNavbarSearch.main,
        marginRight: "0.5rem",
        marginLeft: "1rem",
    },
    searchInput: {
        color: theme.palette.adminNavbarSearch.main,
        width: "270px",
        backgroundColor: "initial",
        border: 0,
        boxShadow: "none",
        padding: "0",
    },
    containerRoot: {
        [theme.breakpoints.up("md")]: {
            paddingLeft: 0,
            paddingRight: 30,
        },
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 600
    },
    breadcrumb: {
        "&:hover": {
            cursor: "pointer"
        }
    },

    logoBox: {
        minHeight: 50,
        paddingBottom: "unset",
        width: 250,
        paddingTop: 5,
        marginRight: 20,
    },
    logoClasses: {
        maxHeight: "2rem",
        maxWidth: "100%",
        verticalAlign: "middle",
        borderStyle: "none",
        [theme.breakpoints.up("md")]: {
            maxHeight: "2.5rem",
        },
        margin: "0 15px"
    },
    logoLinkClasses: {
        fontSize: "1.25rem",
        lineHeight: "inherit",
        whiteSpace: "nowrap",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        height: "100%"
    },
    logoLinkText: {
        color: theme.palette.primary.main,
        margin: "12px 0 0 0",
        fontWeight: "bold",
    },
});

export default componentStyles;
